<div class="padding-vertical-xxsmall user-data" *ngIf="!userDataLoading; else noData">
  <div class="grid align-center padding-horizontal-medium">
    <div class="cell cell-large-col-span-6 cell-medium-col-span-8 cell-large-col-start-4">
      <div *ngIf="userDetails" class="margin-bottom-large">
        <p class="text-large">Hi {{ userDetails.first_name }}</p>
        <h1 *ngIf="policyDisplayType !== 'old'">How can we help today?</h1>
        <h1 *ngIf="policyDisplayType === 'old'">Your cancelled and inactive policies</h1>
      </div>

      <!-- Missed payments notification -->
      <div class="margin-bottom-large" *ngIf="overdueInvoices && overdueInvoices.length > 0">
        <ng-container *ngFor="let invoice of overdueInvoices">
          <open-tile-block
            [title]="invoice.overdueInvoices.count > 1 ? 'You have outstanding payments' : 'You have an outstanding payment'"
            [text]="'Retry or change your payment details on the policy: ' + invoice.policyTitle"
            (action)="retryPayment(invoice.slug)"
            [tileClass]="'error-notification'"
          ></open-tile-block>
        </ng-container>
      </div>

      <!-- Appointment notification -->
      <div class="margin-bottom-large" *ngIf="!overdueInvoices || overdueInvoices.length === 0">
        <app-appointment-list></app-appointment-list>
      </div>



      <div class="grid" *ngIf="memberNumberLink">
        <div class="cell cell-large-col-span-12 margin-bottom-medium dashboard-shortcuts">
          <ul>
            <li>
              <a [routerLink]="['/user/member-validation']">
                <open-svg-icon name="management-managepolicies" class="margin-right-xxsmall"></open-svg-icon>
                <span>Link your account and start earning Avios</span>
                <mat-icon class="east margin-left-xxsmall"></mat-icon>
              </a>
            </li>
          </ul>
        </div>
      </div>



      <!-- Messaging when customer has no policies -->
      <div class="padding-top-small" *ngIf="policies && policies.length === 0">
        <div class="padding-large no-policies text-center">
          <p class="padding-bottom-small">You don't have any active policies with us.</p>
          <button mat-flat-button color="primary" (click)="redirectToBaseDomain()" *ngIf="!hasQuotableProductClasses">
            Start a quote
          </button>
        </div>
      </div>
      <!-- Product class sections created for classes where policies exist -->
      <div *ngIf="policies && policies.length > 0" >
        <ng-container *ngFor="let product of productDisplaySections; index as classIndex">
          <div *ngIf="getPoliciesCount(product.class) > 0" class="margin-bottom-large">
            <div class="flex margin-bottom-xsmall">
              <open-svg-icon class="xsmall dark" [name]="product.icon"></open-svg-icon>
              <span class="policy-section-title text-small flex flex-items-center">{{ product.class | titlecase }} insurance</span>
            </div>
            <ng-container *ngFor="let policy of policies">
              <open-tile-block *ngIf="policy.class === product.class" [title]="policy.policyTitle" [text]="policy.policyTypeLabel" (action)="goToPolicy(policy.slug)">
                <div class="flex">
                  <open-badge style="margin-right: 10px;" [label]="policy.status" [variant]="badgeStatus[policy.status] || 'default'"></open-badge>
                  <open-badge label="Active claim" variant="transparent" icon="info_outline material-icons-outlined" *ngIf="policy.claims"></open-badge>
                </div>
              </open-tile-block>
            </ng-container>
            <ng-container *ngIf="quotableProductClasses && quotableProductClasses[product.class] && policyDisplayType !== 'old'">
              <open-tile-block [title]="quotableProductClasses[product.class].title" [text]="quotableProductClasses[product.class].text" [tileClass]="'tertiary'" [actionText]="quotableProductClasses[product.class].actionText" (action)="createQuote(product.class, quotableProductClasses[product.class].multiProduct)" [actionInProgress]="quotableProductClasses[product.class].creatingQuote"></open-tile-block>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <!-- Product class sections created for classes where policies DO NOT exist -->
      <div *ngFor="let item of quotableProductClasses | keyvalue">
        <div class="margin-bottom-large" *ngIf="getPoliciesCount(item.key) === 0 && policyDisplayType !== 'old'">
          <div class="flex margin-bottom-xsmall">
            <open-svg-icon class="xsmall dark" [name]="item.value.icon"></open-svg-icon>
            <span class="policy-section-title text-small flex flex-items-center">{{ item.key | titlecase }} insurance</span>
          </div>

          <open-tile-block [title]="item.value.title" [text]="item.value.text" [tileClass]="'tertiary'" [actionText]="item.value.actionText" (action)="createQuote(item.key, item.value.multiProduct)" [actionInProgress]="item.value.creatingQuote"></open-tile-block>
        </div>
      </div>

      <div>
        <div class="margin-bottom-medium dashboard-shortcuts">
          <p class="text-small margin-bottom-xsmall"><strong>Your shortcuts</strong></p>
          <ul>
            <li *ngIf="policyDisplayType !== 'old' && oldPolicies && oldPolicies.length > 0">
              <a (click)="getPolicyDisplayTypes()">
                <open-svg-icon name="management-startclaim" class="margin-right-xxsmall"></open-svg-icon>
                <span class="dashboard-shortcuts-label">View cancelled & inactive policies</span>
                <mat-icon class="east margin-left-xxsmall"></mat-icon>
              </a>
            </li>
            <li *ngIf="policyDisplayType === 'old'">
              <a (click)="getPolicyDisplayTypes()">
                <open-svg-icon name="management-startclaim" class="margin-right-xxsmall"></open-svg-icon>
                <span class="dashboard-shortcuts-label">View active policies</span>
                <mat-icon class="east margin-left-xxsmall"></mat-icon>
              </a>
            </li>
            <li *ngIf="environment.region !== 'uk'">
              <a [routerLink]="['/emergency']">
                <open-svg-icon name="management-emergencyhelp" class="margin-right-xxsmall"></open-svg-icon>
                <span class="dashboard-shortcuts-label">Get emergency assistance</span>
                <mat-icon class="east margin-left-xxsmall"></mat-icon>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noData>
  <!-- Spinner if userData is being fetched -->
  <div class="padding-xxbig flex flex-justify-center" *ngIf="userDataLoading">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <p *ngIf="!userDataLoading;">No data...</p>
</ng-template>
